import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="top-0 z-50 bg-[#003594]">
      <div className="max-w-7xl mx-auto px-6 h-36 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo192.png" alt="Pitt shield" className="w-14 h-14 object-contain" />
          <div className="flex flex-col leading-none">
            <span style={{ fontFamily: "'Crimson Pro', Georgia, serif" }} className="font-semibold text-white text-4xl tracking-tight">
              Pitt Pavements
            </span>
            <span style={{ fontFamily: "'DM Mono', monospace" }} className="text-[#FFB81C] text-md tracking-[0.14em] uppercase">
              App Hub
            </span>
          </div>
        </Link>

        <div className="hidden sm:flex items-center">
          <a href="https://pavements.pitt.edu/" target="_blank" rel="noopener noreferrer" className="px-4 py-2 rounded text-sm font-semibold bg-[#FFB81C] text-[#001f5b] hover:bg-[#ffd06a] transition-colors duration-200">Research</a>
        </div>

        <button className="sm:hidden flex flex-col gap-1.5 p-1.5" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className="block w-5 h-0.5 bg-white rounded" />
          <span className="block w-5 h-0.5 bg-white rounded" />
          <span className="block w-5 h-0.5 bg-white rounded" />
        </button>
      </div>

      {menuOpen && (
        <div className="sm:hidden bg-[#00276e] border-t border-[#FFB81C]/20 px-6 py-3 flex flex-col gap-1">
          <a href="https://pavements.pitt.edu/" target="_blank" rel="noopener noreferrer" className="py-3 text-sm text-white/80 hover:text-[#FFB81C] transition-colors duration-200">Full Site</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;